import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_DIVIDENDS = 'REQUEST_DIVIDENDS'
export const RECEIVE_DIVIDENDS = 'RECEIVE_DIVIDENDS'
export const SAVE_DIVIDEND = 'SAVE_DIVIDEND'

export const requestDividends = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_DIVIDENDS, data: { taxReturnId } })

    axios
        .get(`/dividends?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receiveDividends({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveDividends({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveDividends({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveDividends = (data) => ({ type: RECEIVE_DIVIDENDS, data })

export const saveDividend = (data) => (dispatch) => {
    dispatch({ type: SAVE_DIVIDEND, data })

    const { id } = data

    return axios
        .put(`/dividends/${id}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveDividends({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const updateAndSaveDividends = (data) => (dispatch) => {
    dispatch(receiveDividends({ items: [data] }))
    return dispatch(saveDividend(data)).catch(() => {})
}
